import { useLingui } from '@lingui/react/macro';

import { MobileBrandFilter } from '@/components/SharedFilters/BrandFilter/MobileBrandFilter';
import { useCurrentOrganization } from '@/services/auth';

import { useFilters } from '../FiltersState';

export const MobileFiltersArticleBrand = () => {
  const { t } = useLingui();
  const [organization] = useCurrentOrganization();

  const {
    articleBrands: { articleBrands, setArticleBrands },
  } = useFilters();

  return (
    <MobileBrandFilter
      filterId="article-brand"
      selectedBrands={articleBrands}
      setSelectedBrands={setArticleBrands}
      brandsQuery={{ organizationId: organization?.id, limit: 500, offset: 0 }}
      label={t({
        id: 'settings.organization.entities.agreements.filters.article_brand.label',
        message: 'Article brand',
      })}
    />
  );
};
